import React, { Component } from 'react';
import { Menu, Icon } from 'antd';
import {isLogin} from '../../modules/Authentication';
import './custom.css';
import ACL from '../ACL';
import {LOG_VIEWER} from '../../constants/config';

const { SubMenu } = Menu;

export default class Sidebar extends Component {
    constructor() {
        super();
        this.state = {
            collapsed: true,
        }
    }

    toggleCollapsed = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    logout() {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userInfo');
        window.location.replace('/login');
    }

    render() {
        const {history} = this.props;

        let menuItems = (
            <ACL component={Menu}
                 defaultOpenKeys={['sub1']}
                 mode="inline"
                 theme="dark"
                 style={{width: '100%'}}
                 inlineCollapsed={this.state.collapsed}
                >
                <Menu.Item key="0" onClick={() => {history.push("/")}}>
                    داشبورد
                </Menu.Item>
                <Menu.Item key="1" has_permission="coupons_management|coupons_list"
                           onClick={() => {history.push("/coupons")}}>
                    قرعه کشی ها
                </Menu.Item>

                <Menu.Item key="200" has_permission="coupons_management|coupons_list"
                           onClick={() => {history.push("/special-coupons")}}>
                    قرعه کشی های خاص
                </Menu.Item>

                <Menu.Item key="2" has_permission="stores_management|stores_list"
                           onClick={() => {history.push("/stores")}}>
                    فروشگاه ها
                </Menu.Item>


                <Menu.Item key="3" has_permission="users_management|users_list" onClick={() => {history.push("/users")}}>
                    کاربران
                </Menu.Item>

                <Menu.Item key="4" has_permission="events_management|events_list"
                           onClick={() => {history.push("/events")}}>
                    رویدادها
                </Menu.Item>

                <Menu.Item key="201"
                           onClick={() => {history.push("/jobs")}}>
                    فرصت های شغلی
                </Menu.Item>

                <Menu.Item key="5" has_permission="contact_management|contact_list"
                           onClick={() => {history.push("/contact-us")}}>
                    فرم تماس
                </Menu.Item>

                <Menu.Item key="6" has_permission="newsletter_management|newsletter_list"
                           onClick={() => {history.push("/newsletter")}}>
                    خبرنامه گردونه
                </Menu.Item>

                <Menu.Item key="7" has_permission="subscribers_management|subscribers_list"
                           onClick={() => {history.push("/subscribers")}}>
                    خبرنامه فروشگاه ها
                </Menu.Item>

                <Menu.Item key="8" has_permission="newsletters_logger_management|newsletters_logger_list"
                           onClick={() => {history.push("/logger/newsletters")}}>
                    لاگ خبرنامه فروشگاه
                </Menu.Item>

                <Menu.Item key="9" has_permission="popularstores_management|popularstores_list"
                           onClick={() => {history.push("/popularstores")}}>
                    فروشگاه‌های محبوب
                </Menu.Item>

                <Menu.Item key="10" has_permission="wall_management|wall_list" onClick={() => {history.push("/wall")}}>
                    دیوار
                </Menu.Item>

                <Menu.Item key="11" has_permission="comments_management|comments_list"
                           onClick={() => {history.push("/comments")}}>
                    نظرات
                </Menu.Item>

                <Menu.Item key="12" has_permission="sliders_management|sliders_list"
                           onClick={() => {history.push("/sliders")}}>
                    اسلایدرها
                </Menu.Item>

                <Menu.Item key="13" has_permission="workus_management|workus_list"
                           onClick={() => {history.push("/work-with-us")}}>
                    همکاری با ما
                </Menu.Item>

                <Menu.Item key="14" has_permission="categories_management|categories_list"
                           onClick={() => {history.push("/categories")}}>
                    دسته‌بندی‌ها
                </Menu.Item>


                <ACL has_permission="application" component={SubMenu}
                     key="16"
                     title={
                    <span style={{color: '#fff'}}>
                        اپلیکیشن
                        <Icon type="arrow-left" style={{paddingRight: '5px'}} />
                    </span>
                }
                    >
                    <Menu.Item style={{textAlign: 'right'}} key="35" onClick={() => {history.push("/app-home")}}>
                        خانه
                    </Menu.Item>

                    <Menu.Item style={{textAlign: 'right'}} key="36" onClick={() => {history.push("/app-sliders")}}>
                        اسلایدرها
                    </Menu.Item>
                </ACL>

                <Menu.Item has_permission="bulk-messages_management|bulk-messages_list" key="17" onClick={() => {history.push("/bulk-messages")}}>
                    پیامک انبوه
                </Menu.Item>

                <Menu.Item has_permission="history_management|history_list" key="18"
                           onClick={() => {history.push("/history")}}>
                    تاریخچه تغییرات
                </Menu.Item>

                <Menu.Item has_permission="pages_management|pages_list" key="19"
                           onClick={() => {history.push("/pages")}}>
                    صفحات
                </Menu.Item>

                <Menu.Item has_permission="acl_management" key="20"
                           onClick={() => {history.push("/acl/roles")}}>
سطح دسترسی
                </Menu.Item>

                <Menu.Item has_permission="referral_management|referral_list" key="21"
                           onClick={() => {history.push("/referral")}}>
مدیریت معرفی به دوستان
                </Menu.Item>

                <Menu.Item has_permission="lucky_wheels_management|lucky_wheels_list" key="22"
                           onClick={() => {history.push("/lucky_wheels")}}>
مدیریت گردونه شانس
                </Menu.Item>
		
                <Menu.Item has_permission="notification_management|notification_add" key="23"
                           onClick={() => {history.push("/notifications")}}>
مدیریت پوش
                </Menu.Item>

                <Menu.Item key="25" onClick={() => {this.logout()}}>
                    خروج
                </Menu.Item>
            </ACL>
        )
        return (
            <div style={{display: isLogin() ? 'block': 'none', height: '100vh', backgroundColor: '#001529'}}>
                {menuItems}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js